import { motion } from 'framer-motion';
import { COACHES } from './data';
// COACHES — trading-card style with stat block
export default function Coaches({ setPage }) {
  return (
    <div className="bg-[#0A0A0A] text-white">
      <section className="pt-12 pb-8 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#F2C500]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F2C500] mb-3">▶ Section 03 / Coaches</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92]">Three coaches, <span className="italic text-[#F2C500]">no body of part-timers</span>.</h1>
      </section>
      <section className="max-w-[1500px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-3 gap-px bg-white/15">
        {COACHES.map((c, i) => (
          <motion.div key={c.name} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="bg-[#0A0A0A] p-8 group">
            <div className="aspect-[4/5] overflow-hidden bg-[#1A1A1A] mb-5 relative">
              <img src={c.img} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
              <div className="absolute top-3 left-3 font-mono text-[9px] tracking-[0.4em] uppercase bg-[#F2C500] text-[#0A0A0A] px-2 py-1">COACH 0{i + 1}</div>
            </div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F2C500]">{c.role}</p>
            <p className="font-serif text-3xl mt-1">{c.name}</p>
            <p className="text-sm text-white/65 mt-3 leading-[1.6]" dangerouslySetInnerHTML={{ __html: c.cred }} />
            <button onClick={() => setPage('trial')} className="mt-5 w-full bg-white/5 hover:bg-[#F2C500] hover:text-[#0A0A0A] py-3 font-mono text-[10px] tracking-[0.3em] uppercase border border-white/15 transition-colors">Book session with {c.name.split(' ')[1]} →</button>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
